import { Search, Loader2 } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

interface HostFormProps {
  host: string;
  onHostChange: (host: string) => void;
  onSubmit: (host: string) => void;
  isLoading: boolean;
  showComments: boolean;
  onShowCommentsChange: (show: boolean) => void;
}

export function HostForm({
  host,
  onHostChange,
  onSubmit,
  isLoading,
  showComments,
  onShowCommentsChange,
}: HostFormProps) {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (host.trim()) {
      onSubmit(host.trim());
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="flex gap-2">
        <Input
          type="text"
          placeholder="IP адрес или домен"
          value={host}
          onChange={(e) => onHostChange(e.target.value)}
          className="flex-1"
        />
        <Button type="submit" disabled={isLoading || !host.trim()}>
          {isLoading ? (
            <Loader2 className="w-4 h-4 animate-spin" />
          ) : (
            <Search className="w-4 h-4" />
          )}
        </Button>
      </div>

      <div className="flex items-center gap-2">
        <Checkbox
          id="showComments"
          checked={showComments}
          onCheckedChange={(checked) => onShowCommentsChange(checked === true)}
        />
        <Label htmlFor="showComments" className="text-sm text-muted-foreground">
          Show Comment Lines
        </Label>
      </div>
    </form>
  );
}
